var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-container',{staticClass:"items-center justify-center",attrs:{"fluid":"","fill-height":""}},[_c('Loader',{attrs:{"label":"Вход..."}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }